import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => {
  Sentry.captureException(err);
  console.error(err);
});
